export default __webpack_public_path__ + "static/media/IMG_5378.7115fc32.JPG";